import React from "react";

export default function NotesTable({ notes, loading, onView }) {
  return (
    <div className="cnl-table">
      <div className="cnl-thead">
        <div>ID</div>
        {/* <div>Template</div>
        <div>Fecha/Hora</div>
        <div>Usuario</div> */}
        <div>Template</div>
        <div></div>
      </div>

      {notes.length === 0 && !loading && (
        <div className="cnl-empty">There are no notes to display.</div>
      )}

      {notes.map((n) => (
        <div key={n.id} className="cnl-row">
          <div className="mono">{n.id}</div>
          {/* <div className="truncate">{n.templatename}</div>
          <div className="mono">{n.notedatetime}</div>
          <div className="truncate">{n.username}</div> */}
          <div className="truncate">{n.comments ?? ""}</div>
          <div>
            <button className="btn" onClick={() => onView(n)}>
              Ver
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
